import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import useProfilePicture from "../../swrCustomHooks/useProfilePicture"
import userDefaultImage from "../../assets/img/user-default.svg"

export default function ProfilePicture({idUser}) {
    const {sessionContext, setSessionAction} = useSessionContext()
    const {profilePicture} = useProfilePicture(idUser ? idUser : sessionContext.idUser, sessionContext.idToken, setSessionAction)
    return <img className="profile-picture" src={(!profilePicture || profilePicture?.message) ? userDefaultImage : profilePicture} alt=""/>
}